import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-plus",
  "use": "icon-plus-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"#00314A\" stroke-linecap=\"round\" stroke-linejoin=\"round\" id=\"icon-plus\"><path d=\"M8 12h8m-4-4v8\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol